var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo34(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 37,
    viewBox: "0 0 248 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M72.1738 26.9119C70.6705 26.0971 69.4923 24.9715 68.6395 23.5343C67.7865 22.0977 67.3604 20.4766 67.3604 18.6717C67.3604 16.8671 67.7911 15.2462 68.6527 13.809C69.514 12.3725 70.6969 11.2464 72.2003 10.4316C73.7037 9.61675 75.3871 9.20935 77.2511 9.20935C78.7632 9.20935 80.1433 9.47218 81.392 9.99783C82.6403 10.5235 83.6953 11.2859 84.5571 12.2847L82.3415 14.361C81.005 12.9245 79.3611 12.2057 77.4094 12.2057C76.1433 12.2057 75.0092 12.4817 74.0069 13.0337C73.0047 13.5857 72.2221 14.3525 71.6596 15.3336C71.0966 16.3151 70.8155 17.4278 70.8155 18.6718C70.8155 19.9161 71.0966 21.0286 71.6596 22.01C72.2221 22.9915 73.0047 23.7578 74.0069 24.3098C75.0092 24.8618 76.1433 25.1378 77.4094 25.1378C79.3611 25.1378 81.005 24.4107 82.3415 22.9562L84.5571 25.0588C83.6953 26.0576 82.6358 26.8198 81.3788 27.3457C80.1215 27.8713 78.7367 28.1342 77.2247 28.1342C75.3607 28.1342 73.6772 27.7267 72.1738 26.9119Z",
    fill: "url(#paint0_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M99.4322 23.6133H90.2008L88.3809 27.8714H84.8467L93.1549 9.47223H96.5309L104.865 27.8714H101.279L99.4322 23.6133ZM98.2981 20.9321L94.8165 12.8892L91.3614 20.9321H98.2981Z",
    fill: "url(#paint1_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M123.618 9.47223V27.8714H120.796L110.615 15.4126V27.8714H107.213V9.47223H110.035L120.216 21.931V9.47223H123.618Z",
    fill: "url(#paint2_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M140.551 23.6133H131.32L129.5 27.8714H125.966L134.274 9.47223H137.65L145.985 27.8714H142.398L140.551 23.6133ZM139.417 20.9321L135.936 12.8892L132.48 20.9321H139.417Z",
    fill: "url(#paint3_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M148.331 9.47223H156.402C158.371 9.47223 160.121 9.85331 161.651 10.6157C163.18 11.3778 164.367 12.4555 165.211 13.8486C166.055 15.2417 166.477 16.8496 166.477 18.6718C166.477 20.4945 166.055 22.1019 165.211 23.495C164.367 24.8881 163.18 25.9658 161.651 26.7279C160.121 27.4903 158.371 27.8714 156.402 27.8714H148.331V9.47223ZM156.244 24.9801C157.597 24.9801 158.789 24.7216 159.818 24.2048C160.846 23.6881 161.637 22.952 162.191 21.9968C162.745 21.0418 163.022 19.9335 163.022 18.6718C163.022 17.4101 162.745 16.3022 162.191 15.3468C161.637 14.392 160.846 13.6559 159.818 13.1389C158.789 12.6222 157.597 12.3635 156.244 12.3635H151.76V24.9801L156.244 24.9801Z",
    fill: "url(#paint4_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M170.117 9.47223H173.546V27.8714H170.117V9.47223Z",
    fill: "url(#paint5_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M192.377 25.0064V27.8714H178.53V9.47223H192.008V12.3372H181.959V17.121H190.874V19.9335H181.959V25.0064L192.377 25.0064Z",
    fill: "url(#paint6_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M212.607 9.47223V27.8714H209.785L199.605 15.4126V27.8714H196.202V9.47223H199.024L209.205 21.931V9.47223H212.607Z",
    fill: "url(#paint7_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M219.162 27.5295C217.834 27.1268 216.783 26.5923 216.01 25.9263L217.197 23.2715C217.953 23.8675 218.88 24.3537 219.979 24.7304C221.078 25.1073 222.182 25.2955 223.289 25.2955C224.661 25.2955 225.685 25.0766 226.362 24.6382C227.039 24.2006 227.377 23.6223 227.377 22.9035C227.377 22.3779 227.188 21.9442 226.81 21.6026C226.432 21.2608 225.953 20.9938 225.373 20.8007C224.793 20.6081 224.002 20.3894 222.999 20.1437C221.592 19.8111 220.454 19.478 219.584 19.1448C218.713 18.8122 217.966 18.2907 217.342 17.581C216.717 16.8713 216.405 15.9119 216.405 14.7028C216.405 13.6869 216.682 12.7624 217.236 11.9298C217.79 11.0979 218.625 10.4362 219.742 9.94543C220.858 9.4551 222.225 9.20938 223.843 9.20938C224.968 9.20938 226.076 9.34979 227.167 9.62995C228.257 9.91054 229.197 10.3133 229.989 10.839L228.907 13.4938C228.098 13.0206 227.254 12.6617 226.375 12.4162C225.496 12.1709 224.643 12.048 223.817 12.048C222.463 12.048 221.456 12.276 220.797 12.7314C220.138 13.1873 219.808 13.7919 219.808 14.5451C219.808 15.0708 219.997 15.5003 220.375 15.8331C220.753 16.1662 221.232 16.429 221.812 16.6216C222.393 16.8147 223.184 17.0336 224.186 17.2787C225.558 17.5941 226.683 17.9226 227.562 18.2644C228.441 18.606 229.193 19.1277 229.817 19.8284C230.441 20.5293 230.754 21.4755 230.754 22.667C230.754 23.6835 230.477 24.6034 229.923 25.4269C229.369 26.2507 228.529 26.9078 227.404 27.3981C226.278 27.8885 224.907 28.1342 223.289 28.1342C221.865 28.1342 220.489 27.9326 219.162 27.5295Z",
    fill: "url(#paint8_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M248.002 25.0064V27.8714H234.155V9.47223H247.633V12.3372H237.584V17.121H246.499V19.9335H237.584V25.0064L248.002 25.0064Z",
    fill: "url(#paint9_linear_22_54)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M1.46241 0H53.0291H54.4916V1.45737V7.04049H51.5874V2.91473H2.90418V33.4373H51.5874V29.3116H54.4916V34.8741V36.3315H53.0291H1.46241H0V34.8741V1.45737V0H1.46241Z",
    fill: "url(#paint10_linear_22_54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M30.9082 8.88785V27.5668H34.2244V22.1068H37.4994C39.868 22.1068 41.7835 21.491 43.2048 20.2595C44.6672 19.0279 45.3881 17.3652 45.3881 15.3331C45.3881 13.3831 44.7084 11.8436 43.349 10.6737C41.9895 9.48315 40.1976 8.88785 37.973 8.88785L30.9082 8.88785ZM34.2244 19.0689V11.9258H37.8701C40.4035 11.9258 42.1131 13.2804 42.1131 15.3331C42.1131 17.5705 40.4035 19.0689 37.8701 19.0689H34.2244ZM50.9082 21.4089L55.9751 27.5668H60.0122L54.5745 20.9368C57.2109 20.0747 58.8793 17.9195 58.8793 15.1484C58.8793 13.2804 58.179 11.7616 56.8402 10.6121C55.4807 9.46258 53.7094 8.88785 51.5879 8.88785H43.9051V27.5668H47.2007V21.4089H50.9082ZM47.2007 18.371V11.9258H51.4849C53.8742 11.9258 55.625 13.1984 55.625 15.1484C55.625 17.0984 53.8742 18.371 51.4849 18.371L47.2007 18.371Z",
    fill: "url(#paint11_linear_22_54)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M21.7279 21.8408L26.2283 18.2854L25.2965 17.7216C25.1368 17.598 24.9711 17.5915 25.0665 17.2463L25.9321 14.1483L23.4569 14.6131C23.0482 14.6761 22.9177 14.5926 22.8234 14.3419L22.2921 13.2952L20.4023 15.7503C20.0138 16.1726 19.5198 15.9084 19.6081 15.3981L20.6324 10.0641L20.5743 10.1036L20.5837 10.0641L19.4184 10.8567C19.2475 10.9853 19.0265 11.0742 18.8116 11.0796C18.5935 11.0718 18.386 10.9731 18.2486 10.733L16.7487 7.70563L16.725 7.7535L16.7013 7.70563L15.2013 10.733C15.064 10.9731 14.8564 11.0718 14.6384 11.0796C14.4234 11.0742 14.2026 10.9853 14.0315 10.8567L12.8663 10.0641L12.8756 10.1036L12.8176 10.0641L13.8419 15.3981C13.9301 15.9084 13.4362 16.1726 13.0476 15.7503L11.1579 13.2952L10.6266 14.3419C10.5323 14.5926 10.4018 14.6761 9.99307 14.6131L7.51787 14.1483L8.3835 17.2463C8.47883 17.5915 8.31319 17.598 8.15348 17.7216L7.22168 18.2854L11.7221 21.8408C12.0374 22.092 12.0596 22.4146 11.9341 22.7914L11.4933 24.1818L15.5378 23.6009C15.9806 23.5124 16.1975 23.906 16.1975 24.2196L16.071 28.4592H17.379L17.2525 24.2196C17.2525 23.906 17.4694 23.4978 17.9122 23.5863L21.9567 24.1745L21.5159 22.7877C21.3904 22.4109 21.4126 22.092 21.7279 21.8408Z",
    fill: "url(#paint12_linear_22_54)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_54",
    x1: 67.3604,
    y1: 18.6717,
    x2: 248.003,
    y2: 18.6717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22_54",
    x1: 67.3601,
    y1: 18.6718,
    x2: 248.003,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_22_54",
    x1: 67.3603,
    y1: 18.6718,
    x2: 248.003,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_22_54",
    x1: 67.3605,
    y1: 18.6718,
    x2: 248.003,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_22_54",
    x1: 67.3596,
    y1: 18.6718,
    x2: 248.002,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_22_54",
    x1: 67.3601,
    y1: 18.6718,
    x2: 248.003,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_22_54",
    x1: 67.3598,
    y1: 18.6718,
    x2: 248.002,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_22_54",
    x1: 67.3603,
    y1: 18.6718,
    x2: 248.003,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_22_54",
    x1: 67.3603,
    y1: 18.6718,
    x2: 248.003,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_22_54",
    x1: 67.3596,
    y1: 18.6718,
    x2: 248.002,
    y2: 18.6718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74C9BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BC0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_22_54",
    x1: 0,
    y1: 18.1658,
    x2: 60.0117,
    y2: 18.1658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8981D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_22_54",
    x1: 0.000545128,
    y1: 18.1657,
    x2: 60.0122,
    y2: 18.1657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8981D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_22_54",
    x1: 7.22168,
    y1: 18.0824,
    x2: 26.2283,
    y2: 18.0824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8981D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo34);
export default __webpack_public_path__ + "static/media/Logo34.aa437fbdffeef58a52fed17056fa9e3a.svg";
export { ForwardRef as ReactComponent };